import React from 'react';

interface PaginationInfoProps {
  currentPage?: number;
  perPage?: number;
  total?: number;
  loading?: boolean;
}

const PaginationInfo: React.FC<PaginationInfoProps> = ({
  currentPage = 1,
  perPage = 15,
  total = 0,
  loading = false
}) => {
  if (loading || total === 0) {
    return null;
  }

  const startItem = ((currentPage - 1) * perPage) + 1;
  const endItem = Math.min(currentPage * perPage, total);

  return (
    <div className="flex items-center justify-center text-sm text-gray-600 py-2">
      Mostrando {startItem} a {endItem} de {total} usuarios
    </div>
  );
};

export default PaginationInfo;